import L, { Map } from "leaflet";
import { Position, difference, polygon as poly } from "@turf/turf";
import { AgroMap } from "@/features/map/utils/agromap";
import { MapType } from "@/features/map/utils/agromap.type";
import { splitPolygon } from "@/features/map/utils/split-polygon";
import { Validation } from "@/features/map/domain/agromap.interface";
import { Season } from "@/features/growing-season/domain/growing-season.interface";
export class SeasonMap extends AgroMap {
  constructor(
    popupRef: React.RefObject<HTMLDivElement>,
    toolbarOptions: L.PM.ToolbarOptions,
    markerIcon: L.Icon<L.IconOptions> | L.DivIcon,
    private _type: MapType,
    public parentFarmPolygon: Position[],
    private _farmSeasons?: Season[],
    private _currentSeasonPolygon?: Position[]
  ) {
    super(popupRef, toolbarOptions, _type !== "onlyShow", markerIcon);
  }

  validate(polygon: Position[]): Validation {
    let validation: Validation = { isValid: true, message: "" };
    const diffArea = difference(
      poly([this.parentFarmPolygon]),
      poly([polygon])
    );

    if (diffArea) {
      if (diffArea.geometry.coordinates.length > 1) {
        validation = super.validationResult(
          false,
          "امکان ثبت فصل رشدی که تمام نقاط آن داخل زمین است وجود ندارد"
        );
      }
    }

    polygon.forEach((point) => {
      if (
        !super.isPointInPolygon(
          point,
          super.bufferPolygon(this.parentFarmPolygon, 10)
        )
      ) {
        validation = super.validationResult(
          false,
          "امکان ثبت فصل رشدی خارج از زمین وجود ندارد"
        );
      }

      this._farmSeasons?.forEach((season) => {
        if (
          super.isPointInPolygon(
            point,
            super.bufferPolygon(season.polygon, -10)
          )
        ) {
          validation = super.validationResult(
            false,
            "فصل رشدی نمی تواند با فصل رشدی های دیگر همپوشانی داشته باشد"
          );
        }
      });
    });

    return validation;
  }

  methodWhenCreateEventFired(map: Map, layer: L.Layer): void {
    const upperPolygon = splitPolygon(
      super.closePolygon(this.parentFarmPolygon),
      super.lineToCoordinates(layer),
      1,
      "upper"
    );

    const lowerPolygon = splitPolygon(
      super.closePolygon(this.parentFarmPolygon),
      super.lineToCoordinates(layer),
      -1,
      "lower"
    );

    if (upperPolygon) {
      super.mapChildPolygonsCreatedBySplit(
        //@ts-ignore
        upperPolygon?.geometry.coordinates[0],
        "green"
      );
    }

    if (lowerPolygon) {
      super.mapChildPolygonsCreatedBySplit(
        //@ts-ignore
        lowerPolygon?.geometry.coordinates[0],
        "yellow"
      );
    }
  }

  methodWhenMarkerDrag(_latlng: L.LatLng, layer: L.Layer): void {
    super.setPolygonDetails(
      super.layerToCoordinates(layer),
      "[longitude | latitude]"
    );
  }
}
